export default {
  "content": "<g clip-path=\"url(#clip0)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M1.707.293A1 1 0 00.293 1.707l14 14a1 1 0 001.414-1.414l-14-14zM0 4.5v-.964l.964.964H0zm0 2h2.964l7.5 7.5H1.5A1.5 1.5 0 010 12.5v-6zm10.036 0L16 12.464V6.5h-5.965zM5.536 2l2.5 2.5H16v-1A1.5 1.5 0 0014.5 2H5.536z\" fill=\"#ff00cb\"/></g><defs><clipPath id=\"clip0\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "width": "16",
    "height": "16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};